import request from '@/utils/request'

export function getVoucherLog(params) {
    return request({
        url: '/v2/voucher/getVoucherLog',
        method: 'post',
        data: params
    })
}

export function getVoucherLogExcelDown(params) {
    return request({
        url: '/v2/voucher/getVoucherLogExcelDown',
        method: 'post',
        data: params
    })
}